import { render, staticRenderFns } from "./CustomOptionSelector.vue?vue&type=template&id=cbe0b8f2"
import script from "./CustomOptionSelector.vue?vue&type=script&lang=js"
export * from "./CustomOptionSelector.vue?vue&type=script&lang=js"
import style0 from "./CustomOptionSelector.vue?vue&type=style&index=0&id=cbe0b8f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports